import React from 'react'

import MarkdownContent from 'components/MarkdownContent/MarkdownContent'
import Wrapper from 'components/Wrapper/Wrapper'

export default function MarkdownCmsItem({ source }) {
  return (
    <Wrapper>
      <MarkdownContent source={source} />
    </Wrapper>
  )
}
